module.exports = __webpack_public_path__ + "static/NHaasGroteskTXStd-55Rg-b9fe9c38e889041b80e913eda9b2a2c4.woff";